module.exports = __webpack_public_path__ + "img/filter-selected.47127376.svg";